import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import SiteContext from '../../context/SiteContext';


export default function MapSwitch({getMap1, clearContour, currMapData, style, mapSide=null, selectOrthoRef}) {
  const options = currMapData.visits ;
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(sessionStorage.getItem("visit")??0);
  const {setVisitIndex} = React.useContext(SiteContext)

  const handleClick = () => {
    console.info(`You clicked ${options[selectedIndex]}`);
  };

  const handleMenuItemClick = (event, index, path="volumeSegments") => {
    console.log("called once,",index)
    setVisitIndex(index)
    if(path==="volumeSegments"){
      setSelectedIndex(index);
      setOpen(false);
      if(mapSide !== null){
        getMap1(mapSide, index, path)
      }else{
        getMap1(index, path)
      }
      clearContour();
      setTimeout(() => {
        selectOrthoRef?.current.click();
      }, 500);
    }else{
      setSelectedIndex(index);
      setOpen(false);
      if(mapSide !== null){
        getMap1(mapSide, index, 'orthoPaths')
      }else{
        getMap1(index, 'orthoPaths')
      }
      clearContour();
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <ButtonGroup
        variant="contained"
        size='small'
        ref={anchorRef}
        className='blur-it'
        style={
          window.location.pathname.includes('cmaps') || window.location.pathname.includes('csegments') ?
          {
          position:'absolute',
          top:style.top,
          right:style.right,
          // width:"100%"
          
          zIndex:2
        }:{width:"100%"}
      }
      >
        {options?.length>0&&<Button onClick={handleClick} style={{width:"80%",border:"0.5px solid var(--color-border)"}} sx={{ backgroundColor: 'transparent', '&:hover': { backgroundColor: 'transparent' }, height:"10%" }}>{options[selectedIndex]}</Button>}
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
          style={{width:"20%", height:"10%", border:"0.5px solid var(--color-border)"}}
          sx={{ backgroundColor: 'transparent', '&:hover': { backgroundColor: 'transparent' } }}
        >
          <ArrowDropDownIcon  />
        </Button>
      </ButtonGroup>
      <Popper
        
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        style={{zIndex:2}}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
                backgroundColor:"var(--primary-2)",
                color:"var(--color-font)"
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options?.map((option, index) => (
                    <MenuItem
                      key={`switch_${option}`}
                      disabled={index === 2}
                      selected={index === selectedIndex}
                      style={{border:`0.5px solid ${index===selectedIndex ? "var(--color-border)":"none"}`}}
                      onClick={(event) => handleMenuItemClick(event, index, "volumeSegments")}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}